<template>
  <div>
    <v-data-table
      :items="tableData"
      v-bind="$attrs"
      :rows-per-page-items="[{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
      :pagination="pagination"
      :class="customClass"
      hide-actions
      @update:pagination="updatePagination"
    >
      <template slot="headerCell" slot-scope="props">
        <slot name="headerCell" v-bind="props">{{ props.header.text }}</slot>
      </template>

      <template #items="props">
        <slot name="items" v-bind="props">{{ 'aaa' }}</slot>
      </template>
    </v-data-table>
    <PaginatedTablePagination ref="pagination" style="margin-top: 15px" @go="pullFunction($event)" />
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    customClass: {
      type: String,
      default: ''
    },
    pullFunction: {
      // функция, первым аргументом которой явл. количество страниц
      // предполагается что функция получит от сервера данные и
      // разместит их в компоненте-родителе, который передаст их сюда пропсом
      type: Function,
      required: true
    },
    pagination: {
      default: () => {},
      type: Object
    }
  },
  data () {
    return {
      tableData: []
    }
  },
  watch: {
    items (fresh) {
      this.tableData = fresh
      if (!fresh || !fresh.length) {
        this.$refs.pagination?.canLoadMore(false)
        this.$refs.pagination.onPageEmpty()
      } else {
        const hasMore = fresh.length > 25
        this.$refs.pagination?.canLoadMore(hasMore)
        this.$refs.pagination?.onPageFilled()
      }
    }
  },
  methods: {
    resetPagination () {
      this.$refs.pagination?.reset()
    },
    updatePagination (value) {
      this.$emit('update:pagination', value)
    }
  }
}
</script>
